import { Section } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';
import type { FC } from 'react';
import styled from 'styled-components';
import { GBSectionParagraph, GBSectionTitle } from './StyledElements';

const ContentWrapper = styled(Flex)`
  max-width: 820px;
`;

const BenefitParagraph = styled(GBSectionParagraph)`
  ${MEDIA_QUERIES.tabletAndDesktop`
      white-space: initial;
      text-wrap: balance;
  `}
`;

export interface PublicBenefitProps {
  title: string;
  p1: string;
}

export const PublicBenefit: FC<PublicBenefitProps> = ({ title, p1 }) => {
  return (
    <Section py={[50, 50, 96]} px={20}>
      <GBSectionTitle tabIndex={0}>{title}</GBSectionTitle>
      <ContentWrapper flexDirection="column" alignItems="center" mt={20}>
        <BenefitParagraph tabIndex={0}>{p1}</BenefitParagraph>
      </ContentWrapper>
    </Section>
  );
};
